<template lang="pug">
    #business-info
        v-banner.title-banner(min-height="88")
            .text-h4.font-weight-bold {{editType==1? $t('MyBizes.__AddBiz'): $t('MyBizes.__EditBiz')}}
            template(v-slot:actions)
                v-btn.ml-6(rounded color="primary" @click="saveEdit")  儲存
        v-container.slim-container
            Alert
            v-form(v-model="formValid" ref="businessform")
                .business-info
                    .sub-title.mb-10 {{$t('ContactInfo.__ContactInfo')}}
                    .field-label 
                        span {{$t('ContactInfo.__BizName')}}
                        span.required *
                    v-text-field(v-model="business.name" solo dense outlined required :rules="[rules.required]" )
                    .field-label 
                        span {{$t('ContactInfo.__2sumupId')}}
                        span.required *
                    v-text-field.page-input-field(v-model="business.displayId" solo dense outlined :rules="[rules.required,rules.numberAndLetters, rules.length6to12]" :disabled="editType!=1")
                        template(v-slot:append)
                            v-tooltip(right)
                                template(v-slot:activator="{ on }")
                                    v-btn(icon v-on="on")
                                        v-icon info
                                div(style="max-width:300px") {{$t('ContactInfo.__IDNote')}}
                    .field-label 
                        span {{$t('ContactInfo.__Industry')}}
                        span.required *
                    BizTypeSelector(v-model="business.type" :rules="[rules.required]" :disabled="editType!=1")
                    .field-label 
                        span Email
                        span.required *
                    v-text-field(v-model="business.email" solo dense outlined required :rules="[rules.required, rules.email]")
                    .field-label 
                        span {{$t('ContactInfo.__Tel')}}
                    v-text-field(v-model="business.phone" solo dense outlined )
                    .field-label 
                        span {{$t('ContactInfo.__Mobile')}}
                    v-text-field(v-model="business.mobile" solo dense outlined )
                    .field-label 
                        span {{$t('ContactInfo.__Fax')}}
                    v-text-field(v-model="business.fax" solo dense outlined  )
                    .field-label 
                        span {{$t('ContactInfo.__AccountNumber')}}
                    v-text-field(v-model="business.accountNumber" solo dense outlined  )
                    .field-label 
                        span {{$t('ContactInfo.__BankName')}}
                    v-text-field(v-model="business.bankName" solo dense outlined  )
                    .field-label 
                        span {{$t('ContactInfo.__BankAddress')}}
                    v-text-field(v-model="business.bankAddress" solo dense outlined  )
                    .field-label 
                        span {{$t('ContactInfo.__SwiftCode')}}
                    v-text-field(v-model="business.bankSwiftCode" solo dense outlined  )
                    .field-label 
                        span {{$t('ContactInfo.__Website')}}
                    v-text-field(v-model="business.website" solo dense outlined  )
                    .field-label 
                        span {{$t('ContactInfo.__TaxID')}}
                        span.required
                    v-text-field(v-model="business.taxId" solo dense outlined )
                v-divider.my-10
                .bill-info
                    .field-label 
                        span {{$t('ContactInfo.__Currency')}}
                        span.required *
                    CurrencySelector(v-model="business.currencyCode" :rules="[rules.required]" :disabled="editType!=1" :hint="$t('Auth.__CurrencyNote')")
                    .field-label 
                        span {{$t('ContactInfo.__Timezone')}}
                        span.required *
                    TimezoneSelector(v-model="business.timezone" :rules="[rules.required]" :disabled="editType!=1")
                    .field-label 
                        span {{$t('ContactInfo.__Country')}}
                    CountrySeletor(v-model="business.countryCode" )
                    
                    .field-label 
                        span {{$t('ContactInfo.__ZIPCode')}}
                    v-text-field(v-model="business.billingPostalCode" solo dense outlined )
                    .field-label 
                        span {{$t('ContactInfo.__BillingAddress')}}
                    v-text-field(v-model="business.billingAddress" solo dense outlined )
                    v-text-field(v-model="business.billingAddress2" solo dense outlined )

</template>
<script>
import * as textfieldUtils from "@/utils/textfield.js"
import * as unsaveNotify from "@/utils/unsaveNotify.js"

export default {
  mixins: [unsaveNotify.mixin],
  components: {},
  data() {
    return {
      sumupid: "",
      formValid: false,
      rules: textfieldUtils.rules,
      editType: 1,
      id: 0,
      business: {}
    }
  },
  methods: {
    getBiz(id) {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("bizes/getBiz", id)
        .then(
          function(response) {
            this.business = response.data
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    saveEdit() {
      this.$refs.businessform.validate()
      if (this.formValid) {
        if (this.editType == 1) {
          this.createBiz()
        } else {
          this.updateBiz()
        }
      }
    },
    createBiz() {
      this.$store.dispatch("global/startLoading")
      this.updateShippingInfo()
      this.$store
        .dispatch("bizes/createBiz", this.business)
        .then(
          function(response) {
            this.savedTag = true
            this.$router.push({
              name: "BusinessList",
              params: {
                alert: {
                  message: this.$t("Messages.__SuccessfullyCreated"),
                  type: "success"
                }
              }
            })
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    updateBiz() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("bizes/updateBiz", this.business)
        .then(
          function(response) {
            this.savedTag = true
            this.$router.push({
              name: "BusinessList",
              params: {
                alert: {
                  message: this.$t("Messages.__SuccessfullyUpdated"),
                  type: "success"
                }
              }
            })
            if (this.business.id == this.$store.getters["bizes/bid"]()) {
              this.$store.dispatch("bizes/updateBizInfo", this.business)
            }
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    updateShippingInfo() {
      if (this.isSameAsBilling) {
        ;(this.business.shippingPostalCode = this.business.billingPostalCode),
          (this.business.shippingAddress = this.business.billingAddress),
          (this.business.shippingRecipient = this.business.name),
          (this.business.shippingCountryCode = this.business.billingCountryCode)
      }
    }
  },
  mounted() {
    this.$refs.businessform.resetValidation()
  },
  created() {
    if (this.$route.name == "BusinessNew") {
      this.editType = 1
    } else {
      this.id = this.$route.params.id
      this.editType = 2
      this.getBiz(this.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/formcontrol.scss";
</style>
